const MUTATION_TYPE = {
  // education : courses
  setCourses: 'setCourses',
  pushCourses: 'pushCourses',
  // education: course content
  setCourseContent: 'setCourseContent',
  updateCourseContent: 'updateCourseContent',
  setCoursesPagination: 'setCoursesPagination',
  clearCourseChanges: 'clearCourseChanges',
  setCourseAvatar: 'setCourseAvatar',
  deleteCourseAvatar: 'deleteCourseAvatar',
  setCoursePositions: 'setCoursePositions',
  clearTemporaryIds: 'clearTemporaryIds',
  clearCourseContent: 'clearCourseContent',
  updateCourseStatus: 'updateCourseStatus',
  sortTests: 'sortTests',
  // education: topic
  setCourseTopics: 'setCourseTopics',
  updateCourseTopicTitle: 'updateCourseTopicTitle',
  addTopic: 'addTopic',
  deleteCourseTopic: 'deleteCourseTopic',
  // education: section
  addSection: 'addSection',
  updateCourseSectionTitle: 'updateCourseSectionTitle',
  moveCourseSection: 'moveCourseSection',
  deleteCourseSection: 'deleteCourseSection',
  // education: subsection
  setSubsection: 'setSubsection',
  clearSubSectionInfo: 'clearSubSectionInfo',
  deleteCourseSubsection: 'deleteCourseSubsection',
  addCourseSubsection: 'addCourseSubsection',
  setSubsectionTitle: 'setSubsectionTitle',
  setSubsectionText: 'setSubsectionText',
  setSubsectionAnswer: 'setSubsectionAnswer',
  setSubsectionTextTestVariant: 'setSubsectionTextTestVariant',
  addSubsectionTextTestVariant: 'addSubsectionTextTestVariant',
  deleteSubsectionTextTestVariant: 'deleteSubsectionTextTestVariant',
  addFileToSubsection: 'addFileToSubsection',
  setSubSectionIsSelfTest: 'setSubSectionIsSelfTest',
  setSubSectionPassed: 'setSubSectionPassed',
  setSubsectionInternalIds: 'setSubsectionInternalIds',
  setCourseProgress: 'setCourseProgress',
  setMarksForCourse: 'setMarksForCourse',
  addTestSubSectionsToCourse: 'addTestSubSectionsToCourse',
  setTestSubSectionPosition: 'setTestSubSectionPosition',
  setViewModeSubSectionPosition: 'setViewModeSubSectionPosition',
  prepareCourseTestPositions: 'prepareCourseTestPositions',
  setTestPositions: 'setTestPositions',
  setSubSectionHashes: 'setSubSectionHashes',
  setTestCreationMode: 'setTestCreationMode',
  pushTaskToTest: 'pushTaskToTest',
  setTestContent: 'setTestContent',
  removeTaskFromTest: 'removeTaskFromTest'
}

const ACTION_TYPE = {
  addCourse: 'addCourse',
  fetchCoursesList: 'fetchCoursesList',
  fetchCourseContent: 'fetchCourseContent',
  deleteCourse: 'deleteCourse',
  applyCourseChanges: 'applyCourseChanges',
  fetchSubsection: 'fetchSubsection',
  updateCourse: 'updateCourse',
  updateSubsection: 'updateSubsection',
  deleteSubsection: 'deleteSubsection',
  addNewFileToSubsection: 'addNewFileToSubsection',
  addTextTestVariant: 'addTextTestVariant',
  deleteTextTestVariant: 'deleteTextTestVariant',
  clearCourseContent: 'clearCourseContent',
  sendAnswer: 'sendAnswer',
  fetchCourseProgress: 'fetchCourseProgress',
  setSubSectionPosition: 'setSubSectionPosition',
  applyOnCourse: 'applyOnCourse',
  fetchMarksForCourse: 'fetchMarksForCourse',
  sendSubSectionProgress: 'sendSubSectionProgress',
  sortTests: 'sortTests',
  fetchContentForNewTest: 'fetchContentForNewTest',
  pushTaskToTest: 'pushTaskToTest',
  removeTaskFromTest: 'removeTaskFromTest'
}

const GETTER_TYPE = {
  getCourseContent: 'getCourseContent',
  getSubsection: 'getSubsection',
  getSectionElementPassed: 'getSectionElementPassed',
  getCoursesPagination: 'getCoursesPagination',
  getTopicNames: 'getTopicNames',
  getSectionNames: 'getSectionNames',
  getVariantsForTest: 'getVariantsForTest',
  getCourseProgress: 'getCourseProgress',
  getCourseMember: 'getCourseMember',
  getCourseSubsectionsStructure: 'getCourseSubsectionsStructure',
  getMarksForCourse: 'getMarksForCourse',
  getCourses: 'getCourses',
  isTestCreationMode: 'isTestCreationMode',
  getNewTestTasks: 'getNewTestTasks',
  getTestContent: 'getTestContent',
  getSubSectionHash: 'getSubSectionHash'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
